/* External dependencies */
import gql from 'graphql-tag';

export const redriveTransactionQueueMutation = gql`
  mutation redriveTransactionQueue($input: RedriveTransactionQueueInput!) {
    redriveTransactionQueue(input: $input) {
      id
    }
  }
`;
